import { BaseForm } from './base-form';

export abstract class BaseDetailForm<TEntity> extends BaseForm {

  entity: TEntity;

  constructor() {
    super();
  }

}
